import React, { useEffect, useState } from 'react'
import {  orderChart, orderCount, UserCount } from '../../service/apiService'
import { Chart } from 'primereact/chart'; // For PrimeReact Chart component
import 'chart.js/auto';
import { Dropdown } from 'primereact/dropdown';
        
const Dashboard = () => {
 const [usercounts,setUserCounts] = useState(0)
 const [ordercounts,setOrderCounts] = useState(0)
  const [chartData, setChartData] = useState({});
  const [chartparam, setChartParam] = useState('monthly');

   const chartparamvalues = [
        { name: 'Monthly', code: 'monthly' },
        { name: 'Weekly', code: 'weekly' }
    ];

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false, 
        aspectRatio: 0.8,
        plugins: {
            legend: {
                labels: {
                    font: {
                        size: 14,
                        family: 'Inter, sans-serif'
                    },
                    color: '#FFFFFF' 
                }
            },
            title: {
                display: true,
                text: `${chartparam === 'weekly' ? 'Products Sold (Last 7 Days)' : 'Products Sold (Last 30 Days)'  }`,
                font: {
                    size: 18,
                    family: 'Inter, sans-serif'
                },
                color: '#FFFFFF'
            }
        },
        scales: {
            x: {
                ticks: {
                    font: {
                        family: 'Inter, sans-serif'
                    },
                    color: '#FFFFFF', 
                    
                },
                grid: {
                    color: 'rgba(0,0,0,0.05)' 
                }
            },
            y: {
                ticks: {
                    font: {
                        family: 'Inter, sans-serif'
                    },
                    color: '#6c757d' , 
                    callback: function(value) {
                        return Math.round(value);
                    }
                },
                grid: {
                    color: 'rgba(0,0,0,0.05)' 
                },
                beginAtZero: false
            }
        }
    };

 const init = async () => {
  const data = await UserCount()
  setUserCounts(data?.data?.count)
  const res = await orderCount()
  setOrderCounts(res?.data?.count)
  let orderData = await orderChart(chartparam)
  setChartData(orderData.data)  
 }
  useEffect(() => {
    (async()=> {
      await init()
    })()
  },[])

   useEffect(() => {
    (async()=> {
    let orderData = await orderChart(chartparam)
  setChartData(orderData.data) 
    })()
  },[chartparam])

  return (
    <div>
      <div class="right-content">
                           <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                             <h1>Dashboard</h1> 
                           </div>
                           <div class="container-fluid p-0">
                            <div class="d-flex flex-wrap dashboard-cards justify-content-between">
                             <div class="card">
                               <div class="d-flex justify-content-between">
                                <div className='text-white'>
                                  <h3>Orders</h3>   
                                  <h2>{ordercounts}</h2>
                                  <p><span class="green"><i class="far fa-long-arrow-up"></i> {ordercounts} </span>from previous month</p>   
                                </div>
                                <div class="box-icon">
                                  <img src="/images/tb4.svg" />   
                                </div>
                               </div>
                             </div> 
                             <div class="card">
                               <div class="d-flex justify-content-between">
                                <div className='text-white'>
                                  <h3>Clients</h3>   
                                  <h2>{usercounts}</h2> 
                                  <p><span class="green"><i class="far fa-long-arrow-up"></i> {usercounts} </span>from previous month</p>
                                </div>
                                <div class="box-icon">
                                  <img src="/images/trainers.svg" />   
                                </div>
                               </div>
                             </div> 
                             {/* <div class="card">
                               <div class="d-flex justify-content-between">
                                <div className='text-white'>
                                  <h3>Clients</h3>   
                                  <h2>900</h2> 
                                  <p><span class="green"><i class="far fa-long-arrow-up"></i> 125 </span>from previous month</p>
                                </div>
                                <div class="box-icon">
                                  <img src="/images/clients.svg" />   
                                </div>
                               </div>
                             </div> 
                             <div class="card">
                               <div class="d-flex justify-content-between">
                                <div className='text-white'>
                                  <h3>Total Revenue</h3>   
                                  <h2>£25,100</h2>
                                  <p><span class="green"><i class="far fa-long-arrow-up"></i> 9.32% </span>from previous month</p>   
                                </div>
                                <div class="box-icon">
                                  <img src="/images/total-revenue.svg" />   
                                </div>
                               </div>
                             </div>  */}
                            </div>
                           </div>  
                           <div class='card'>
                           <div className="d-flex justify-content-end">
        <label htmlFor="cancellation-reason">Reason for Cancellation:</label>
        <select 
          id="cancellation-reason"
          value={chartparam} 
          onChange={(e) => setChartParam(e.target.value)}
          required
        >
          <option value="monthly">Monthly</option>
          <option value="weekly">Weekly</option>
        </select>
      </div>
                              {/* <div className="d-flex justify-content-end  align-items-end">
            <Dropdown value={chartparam} onChange={(e) => setChartParam(e.value)} options={chartparamvalues} optionLabel="name" optionValue="code" 
                placeholder="Select Month/Week" className="w-full md:w-14rem" />
        </div> */}

                              {chartData && chartData.labels && chartData.datasets ? (
                        <Chart type="bar" data={chartData} options={chartOptions} />
                    ) : (
                        <div className="text-center text-white">
                            No sales data available for the last 30 days.
                        </div>
                    )}
                           </div>
                        </div>
    </div>
  )
}

export default Dashboard
